import { AccessToken, AuthPluginError } from '@jarvis/jweb-core';
import getPlugins from './getPlugins';

export const getUserToken = async (): Promise<AccessToken> => {
  const { Auth } = await getPlugins();

  const accessToken = await Auth.getToken({
    accountProviderOptions: {
      allowUserInteraction: process.env['REACT_APP_AUTH_ALLOW_USER_INTERACTION'] === 'true',
    },
  });

  const error = (accessToken as AuthPluginError).error;

  if (error) {
    console.error('auth::getUserToken: %o', error);
    throw new Error(error.code);
  }

  return accessToken as AccessToken;
};
